export const TEMPO_MEALS_PER_WEEK = [4, 6, 8, 10, 12, 14, 16, 20];
export const HOME_CHEF_MEALS_PER_WEEK = [2, 3, 4, 5, 6];
